import { AxiosResponse } from 'axios';
import createApiClient from './ApiClient';
import { ResponseDto } from './types/LookDtos';
import { LooksRequestDto } from './types/RequestDtos';
import { FilterColorsType } from '../context/types/FiltersContextType';
import {
  FILTER_MAX_GARMENTS_COUNT,
  FILTER_MIN_GARMENTS_COUNT,
} from '../constants/StylistConstants';

const routes = {
  getLooksByStore: (store: string) => `/stores/${store}/looks`,
  getLooksByGarment: (store: string, garmentId: string) =>
    `/stores/${store}/garments/${garmentId}/looks`,
};

export default class LookApi {
  private static client = createApiClient();
  private static store = 'demo_store';

  public static getLooks(
    pageCursor: string,
    filterGarments: string[],
    filterColors: FilterColorsType[],
    filterGarmentsCount: number[],
  ): Promise<AxiosResponse<ResponseDto>> {
    let garmentsCount: number[] = [];
    if (
      filterGarmentsCount[0] !== FILTER_MIN_GARMENTS_COUNT ||
      filterGarmentsCount[1] !== FILTER_MAX_GARMENTS_COUNT
    ) {
      for (let i = filterGarmentsCount[0]; i <= filterGarmentsCount[1]; i++) {
        garmentsCount.push(i);
      }
    }
    let colors = filterColors.map((color) => color.value);

    const request: LooksRequestDto = {
      pageCursor: pageCursor,
      filter: {
        garmentIds: filterGarments,
        colors: colors,
        garmentsCount: garmentsCount,
      },
    };
    return this.client.post(routes.getLooksByStore(this.store), request);
  }

  public static getLooksByGarment(
    garmentId: string,
    pageCursor: string,
    filterGarments: string[],
    filterColors: string[],
    garmentsCount: number[],
  ): Promise<AxiosResponse<ResponseDto>> {
    const request: LooksRequestDto = {
      pageCursor: pageCursor,
      filter: {
        garmentIds: filterGarments,
        colors: filterColors,
        garmentsCount: garmentsCount,
      },
    };
    return this.client.post(
      routes.getLooksByGarment(this.store, garmentId),
      request,
    );
  }
}
